<template>
<div class="chapter">
<div class="inner_page">
<p class="OT" id="lis"><a id="page_xi"></a><a href="#/xhtml/contents#lis">ILLUSTRATIONS AND TABLES</a></p>
<p class="H1a"><i>Illustrations</i></p>
<table cellpadding="0" cellspacing="0" class="Table1">
<tbody><tr>
<td class="tdleft-r" id="fig_1"><span href="#/xhtml/chapter004#fig1" title="Link target outside of Sample">Figure 1.</span></td>
<td class="tdlefta">The Ear in Land Mammals and Whales, Figure 41 from J. G. M. “Hans” Thewissen, <i>The Walking Whales</i> © University of California Press</td>
</tr>
</tbody></table>
<table cellpadding="0" cellspacing="0" class="Table1">
<tbody><tr>
<td class="tdleft-r" id="plate-1"><span href="#/xhtml/backmatter001#plate_1" title="Link target outside of Sample">Plate 1.</span></td>
<td class="tdlefta">The Ancient Hebrew Conception of the Universe © Michael Paukner</td>
</tr>
<tr>
<td class="tdleft-r" id="plate-2"><span href="#/xhtml/backmatter001#plate_2" title="Link target outside of Sample">Plate 2.</span></td>
<td class="tdlefta"><i>Pakicetus</i> © Roman Uchytel</td>
</tr>
<tr>
<td class="tdleft-r" id="plate-3"><span href="#/xhtml/backmatter001#plate_3" title="Link target outside of Sample">Plate 3.</span></td>
<td class="tdlefta"><i>Ambulocetus natans</i> © Roman Uchytel</td>
</tr>
<tr>
<td class="tdleft-r" id="plate-4"><span href="#/xhtml/backmatter001#plate_4" title="Link target outside of Sample">Plate 4.</span></td>
<td class="tdlefta"><i>Kutchicetus</i> © Roman Uchytel</td>
</tr>
<tr>
<td class="tdleft-r" id="plate-5"><span href="#/xhtml/backmatter001#plate_5" title="Link target outside of Sample">Plate 5.</span></td>
<td class="tdlefta"><i>Maiacetus</i> © Roman Uchytel</td>
</tr>
<tr>
<td class="tdleft-r" id="plate-6"><span href="#/xhtml/backmatter001#plate_6" title="Link target outside of Sample">Plate 6.</span></td>
<td class="tdlefta"><i>Basilosaurus</i> © Roman Uchytel</td>
</tr>
<tr>
<td class="tdleft-r" id="plate-7"><span href="#/xhtml/backmatter001#plate_7" title="Link target outside of Sample">Plate 7.</span></td>
<td class="tdlefta">Lucy © Elisabeth Daynes / LookatSciences</td>
</tr>
<tr>
<td class="tdleft-r" id="plate-8"><span href="#/xhtml/backmatter001#plate_8" title="Link target outside of Sample">Plate 8.</span></td>
<td class="tdlefta"><i>Homo erectus</i> © S. Entressangle, E. Daynes / LookatSciences</td>
</tr>
<tr>
<td class="tdleft-r" id="plate-9"><span href="#/xhtml/backmatter001#plate_9" title="Link target outside of Sample">Plate 9.</span></td>
<td class="tdlefta"><i>Homo neanderthalensis</i> © Elisabeth Daynes / LookatSciences</td>
</tr>
<tr>
<td class="tdleft-r" id="plate-10"><span href="#/xhtml/backmatter001#plate_10" title="Link target outside of Sample">Plate 10.</span></td>
<td class="tdlefta"><i>Homo floresiensis</i> © Elisabeth Daynes / LookatSciences</td>
</tr>
</tbody></table>
<p class="H1"><a id="page_xii">Tables</a></p><a id="page_xii">
<table cellpadding="0" cellspacing="0" class="Table1">
<tbody><tr>
<td class="tdleft-r" id="tab-1"><span href="#/xhtml/chapter003#tab_1" title="Link target outside of Sample">Table 1.</span></td>
<td class="tdlefta">Resemblances between Genesis and Other Ancient Flood Stories</td>
</tr>
<tr>
<td class="tdleft-r" id="tab-2"><span href="#/xhtml/chapter007#tab_2" title="Link target outside of Sample">Table 2.</span></td>
<td class="tdlefta">Comparison of Genesis 5 in Different Textual Traditions</td>
</tr>
<tr>
<td class="tdleft-r" id="tab-3"><span href="#/xhtml/chapter007#tab_3" title="Link target outside of Sample">Table 3.</span></td>
<td class="tdlefta">Comparison of 4QEnc, Greek Fragments, and Jude</td>
</tr>
</tbody></table>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// illustrations.vue?16a4e2fa